export default {
    "zh-cn": {
        "teach.unsupportedBrowser.description": "我们十分抱歉，Scratch并不支持您当前使用的浏览器，我们建议您升级到我们所支持的浏览器的最新版，例如Chrome或者Safari这种标准的浏览器。",
        "teach.navBar.home": "首页",
        "teach.card.more": "更多",
        "teach.user.saveSuccess": "用户信息已保存。",
        "teach.user.login": "登录",
        "teach.user.register": "注册",
        "teach.user.resetPassword": "重置密码",
        "teach.user.changePassword": "修改密码",
        "teach.user.changePhone": "修改手机号",
        "teach.user.logout": "退出",
        "teach.user.logining": "登录中...",
        "teach.user.registering": "注册中...",
        "teach.user.resetting": "重设中...",
        "teach.user.successPhone": "修改成功！",
        "teach.user.changeSuccess": "切换成功！",
        "teach.user.successPassword": "修改成功并已重新登录！",
        "teach.user.changing": "修改中...",
        "teach.user.successLogin": "登录成功！",
        "teach.user.successRegister": "注册成功！",
        "teach.user.successResetPassword": "重置密码并登录成功！",
        "teach.form.phoneFormatError": "手机号码格式错误。",
        "teach.form.passwordFormatError": "密码不符合规范，需要大于6位，并且不能是纯数字",
        "teach.banner.desc": "<li>完整版Scratch 3.0，教学、练习、创作、存储、分享</li>\n" +
            "                 <li>自动化教学引擎，虚拟机器人老师，自主学会编程</li>\n" +
            "                 <li>手把手的过程化指导，复现高手的编码过程</li>\n" +
            "                 <li>循序渐进，解析心法思路，锻炼编程思维</li>\n" +
            "                 <li>课程内容持续制作中，敬请期待...</li>",

        "teach.project.myProjects": "我的作品",
        "teach.project.myProjectsSubtitle": "我的作品我做主",
        "teach.project.recommendedProjects": "推荐作品",
        "teach.project.recommendedProjectsSubtitle": " ",

        "teach.course.saveSuccess": "课程信息已保存。",
        "teach.course.recommendedCourses": "推荐课程",
        "teach.course.recommendedCoursesSubtitle": "课程内容由浅入深排序，持续更新",
        "teach.course.studyingCourses": "学习中课程",
        "teach.course.studyingCoursesSubtitle": "大多数高手都是自学成才的",
        "teach.course.notJoined": "尚未报名",
        "teach.course.pleaseInputClassCode": "需要输入班级码进行验证，可以从该班级的负责老师处获取",
        "teach.course.classCodeIsRequired": "没有班级码，无法报名",
        "teach.course.joinSuccess": "报名成功！",
        "teach.course.courseNotInTheClass": "参数错误：当前班级尚未开启该课程",
        "teach.course.joinCourse": "加入课程",
        "teach.course.joinClass": "加入班级",
        "teach.course.gotoCourse": "直达课程",
        "teach.course.inputCourseId": "请输入课程ID",
        "teach.course.inputClassId": "请输入班级码",

        "teach.lesson.homework": "作业",
        "teach.lesson.locked": "待解锁",
        "teach.lesson.progress_0": "已解锁",
        "teach.lesson.progress_1": "已解锁",
        "teach.lesson.progress_2": "学习中",
        "teach.lesson.progress_3": "待作业",
        "teach.lesson.progress_4": "作业中",
        "teach.lesson.progress_5": "完成",
        'teach.lesson.challengeLockedMessage': "该课程尚未完成解锁，完成前面的课程学习和作业才能解锁哦",
        'teach.lesson.scheduleTimeIs': '该课程的开课时间为：',
        'teach.lesson.notScheduled': '该课程尚未排期',
        "teach.lesson.homeworkNotDone": "作业尚未完成",
        "teach.lesson.homeworkNotStarted": "不存在作业记录",
        "teach.lesson.taskIndexNotExist": "指定的任务序号不存在",
        "teach.lesson.taskNotStarted": "该学生尚未解锁此任务",
        "teach.lesson.noTask": "课程任务建设中...",
        "teach.lesson.taskNav": "任务导航",
        "teach.lesson.switchMember": "切换学生",
        "teach.lesson.comment": "批改",
        "teach.lesson.commented": "已批改",
        "teach.lesson.unCommented": "未批改",
        "teach.lesson.homeworkComment": "作业批改",
        "teach.homework.rate.A": "A",
        "teach.homework.rate.B": "B",
        "teach.homework.rate.C": "C",
        "teach.homework.rate.D": "D",
        "teach.homework.rate.E": "未通过",
        "teach.homework.noRate": "未打分",
        "teach.homework.commentSuccess": "批改成功",
        "teach.lesson.commentedResult" : "批改结果",

        "teach.task": "任务",
        "teach.task.desc": "任务说明",
        "teach.task.completed": "已完成",
        "teach.task.complete": "完成任务",
        "teach.task.typeUndefined": "未知的任务类型",
        "teach.task.currentComplete": "当前任务已完成",
        "teach.task.nextTask": "下一个任务",
        "teach.task.restudy": "再来一遍",
        "teach.lesson.currentComplete": "当前课程已完成",
        "teach.lesson.nextLesson": "学习下一课",
        "teach.lesson.restudy": "再学一遍",
        "teach.lesson.exit": "退出课程",
        "teach.task.guideStart": "引导模式",
        "teach.task.guideExit": "退出引导",
        "teach.task.guideEnd": "练习模式",
        "teach.task.exampleMode": "标准答案",
        "teach.task.submitProject": "提交作品",

        "teach.menu.itemNotAvailable":"该项尚未解锁",

        "teach.class.listPageDesc": "在这里您可以创建班级，关联学校，添加课程，然后分享班级链接邀请同学加入学习。",
        "teach.class.saveSuccess": "班级信息已保存。",
        "teach.class.create.title": "创建班级",
        "teach.class.create.inputClassName": "请输入班级名称",
        "teach.class.create.classNameEmpty": "班级名称不能为空",
        "teach.class.create.inputSchoolName": "请输入学校全称（可不填）",
        "teach.class.create.inputSchoolDesc": "请输入班级介绍（可不填）",
        "teach.class.create.inputSchoolCodeTips": "关联学校码，在学校视图中就能看到您创建的班级啦",
        "teach.class.create.inputSchoolCode": "请输入学校码（可不填）",
        "teach.class.courses": "全部课程",
        "teach.class.members": "班级成员",
        "teach.class.noCourse": "暂无课程",
        "teach.class.noMember": "等待学生加入",
        "teach.class.deleteConfirm": '删除后不可恢复，确定要删除当前班级吗？',
        "teach.class.selectCourses": "选择课程",
        "teach.class.addMemberTips": "发送课程链接给学生，报名者会自动出现在此处",
        "teach.clazz.code": "班级码",
        "teach.clazz.codeNeeded": "报名时需要输入的班级码为",
        "teach.classes.manage": "班级管理",
        "teach.courses.manage": "课程管理",
        "teach.class.shareProject":"班级成员公开作品",


        "teach.course.batchSchedule": "批量排课",
        "teach.course.single": "课程排课",
        "teach.course.batchScheduleTips": "选择第一课开始日期，后续课程将自动设置在每周同一时间",
        "teach.course.singleTips": "设置课程的开始时间",
        "teach.course.noLesson": "没有课",
        "teach.course.inviteToJoin": "邀请加入",
        "teach.course.inviteToJoinTips": "请将以下文本复制给学生",


        "teach.user.helper": "帮助",
        "teach.user.list": "用户列表",
        "teach.user.mine": "个人中心",
        "teach.user.settings":"账号设置",
        "teach.user.teacher":"成为老师",
        "teach.user.myclass":"我的班级",
        "teach.user.addclass":"加入班级",
        "teach.user.addclasses":"已加入的班级",
        "teach.user.createclass":"创建班级",
        "teach.user.createclasses":"我创建的班级",

        "teach.common.saveSuccess": "保存成功",
        "teach.common.deleteSuccess": "删除成功",
        "teach.common.setSuccess": "设置成功",
        "teach.button.set": "设置",
        "teach.button.enter": "进入",
        "teach.button.submit": "提交",
        "teach.button.change": "修改",
        "teach.loading.submit": "提交中...",
        "teach.loading.setting": "设置中...",
        "teach.loading": "载入中...",

        "teach.lesson.experience": "以学生身份试学习",
        "teach.student.change": "切换身份",
        "scratch.app.download": "下载",
        "scratch.app.reload":"刷新"
    }
}
